// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RX_U","name":"styles_name__1X6Oq","phone":"styles_phone__toQk1"};